import React from 'react'

const Responsibility = () => {
    return (
        <section className="terms">
            <div className="row">
                <h2>TERMS AND CONDITIONS</h2>
            </div>

            <div className="row content">
                <div>
                    <p><strong>Description of Service</strong></p>

                    <p>
                        merigold.care is a technology and administrative service provider. We are not a medical provider, or a wholesale distributor. All products described are delivered by independent, third-party licensed delivery facilities.
                    </p>

                    <p>
                        merigold.care is an informational landing page and technology platform. We provide access to information regarding certain products and facilitate communication between users and independent support affiliates. merigold.care is not a medical provider or a logistics entity.
                    </p>

                    <p><strong>Role of Independent Affiliates</strong></p>
                    <p><strong>Independent Support Services</strong></p>

                    <p>
                        Support services are provided by independent affiliates who are not employees or agents of merigold.care. Their role is limited to logistical assistance and administrative coordination. They are strictly prohibited from providing medical advice or influencing clinical decisions.
                    </p>

                    <p>
                        Support affiliates found through this platform are independent contractors. They are not employees or agents of the landing page owner. We do not supervise or control their specific interactions, and we are not liable for any advice or representations they make.
                    </p>

                    <p><strong>Third-Party Fulfillment</strong></p>

                    <p>
                        merigold.care does not own, manage, or control the products.
                    </p>

                    <p>
                        Any orders placed are fulfilled and delivered by an independent, third-party licensed courier.
                    </p>

                    <p>
                        merigold.care is not responsible for the packaging, handling, or delivery of the products.
                    </p>

                    <p>
                        merigold.care complies with all applicable state regulations related to the products.
                    </p>

                    <p>
                        merigold.care does not control, supervise, or guarantee the delivery decisions or the substitution protocols of the third-party facility.
                    </p>

                    <p>
                        merigold.care and its independent support affiliates provide administrative communication services only and do not exercise clinical judgment, medical discretion, or control over delivery protocols.
                    </p>

                    <p>
                        merigold.care disclaims all liability for the selection, efficacy, as well as any representations made by independent affiliates that exceed the scope of logistical order support.
                    </p>

                    <p><strong>User Eligibility</strong></p>

                    <p>
                        By using this site, you represent that you are at least [18] years of age and are accessing the site for informational purposes.
                    </p>

                    <p><strong>LEGAL DISCLAIMER</strong></p>

                    <p><strong>FOR INFORMATIONAL PURPOSES ONLY</strong></p>

                    <p>
                        All content on this website, including text, graphics, and images, is for informational purposes only. It is not intended to be a substitute for professional medical advice, diagnosis, or treatment.
                    </p>

                    <p><strong>NOT A DISPENSARY</strong></p>

                    <p>
                        merigold.care does not manufacture, sell, or deliver products. All products are warehoused and shipped by a third-party, legally licensed logistics entity. Any claims regarding product efficacy or side effects are the responsibility of the owner and the third-party dispensing facility.
                    </p>

                    <p><strong>LIMITATION OF LIABILITY</strong></p>

                    <p>
                        The owner of this landing page shall not be held liable for any damages, injuries, or losses resulting from the use of the products dispensed by third parties or the advice provided by independent affiliates. Your use of this platform constitutes an agreement to indemnify and hold harmless the landing page owner from any legal claims arising from third-party fulfillment or affiliate support.
                    </p>

                    <p>
                        merigold.care disclaims all liability for physical, financial, or data-related harms arising from the clinical decisions of physicians, or any unauthorized representations made by independent affiliates. By using this platform, you acknowledge that merigold.care is an administrative intermediary.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Responsibility